import React, { useMemo } from "react";
import { HStack } from "@design-system/HStack/HStack";
import { Class } from "@common/types/class";
import { useClasses } from "@api/class.api";
import { PlusIcon } from "@icons";
import { ClassAvatarGroup } from "@components/avatar/ClassAvatarGroup";
import { TransactionsFilters } from "../../transactions/filters/lib";
import styles from "./styles.module.scss";

interface ClassFilterTriggerProps {
    value: TransactionsFilters["classes"];
}

const MAX_CLASSES_TO_DISPLAY = 3;

export const ClassFilterTrigger: React.FC<ClassFilterTriggerProps> = ({
    value,
}) => {
    const { classesMap, sortedClassesIndexMap } = useClasses();

    const selectedClasses = useMemo(() => {
        if (!value?.length) {
            return [];
        }

        const extractedClasses = value
            .map((v) => classesMap.get(v))
            .filter(Boolean) as Class[];

        return extractedClasses.toSorted((a, b) => {
            const aIndex = sortedClassesIndexMap.get(a.id) ?? Infinity;
            const bIndex = sortedClassesIndexMap.get(b.id) ?? Infinity;
            return aIndex - bIndex;
        });
    }, [classesMap, value, sortedClassesIndexMap]);

    return selectedClasses.length > 0 ? (
        <ClassAvatarGroup
            classes={selectedClasses}
            max={MAX_CLASSES_TO_DISPLAY}
        />
    ) : (
        <HStack align="center" className={styles.addClass}>
            <PlusIcon /> <span className="ml-1">Add</span>
        </HStack>
    );
};
